import React from "react";
import BaseOptions from "./BaseOptions";

/**
 * @class TitleFieldOptions
 * @extends BaseOptions
 * @description A component which contains a title field options
 */
export default class TitleFieldOptions extends BaseOptions {
  render() {
    return (
      <div>
        {this.renderTitle()}
        {this.renderVisibilityOption()}
      </div>
    );
  }
}
